import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { ResponsivePreview } from '../ResponsivePreview';
import { selectPreviewRevision } from '../../redux/presentationBuilderChat';

const PreviewPaneRoot = styled.div`
  &&& {
    flex: 1;
    min-width: 0;
    min-height: 0;
    display: flex;
    flex-direction: column;
    background: #fff;
    border: 1px solid #e4e4e7;
    border-radius: 8px;
    width: calc(100vw - 400px);
    margin: 8px 16px 8px 2px;
    box-shadow: 0 0 1px 0 rgba(24, 24, 27, 0.30), 0 8px 16px 0 rgba(24, 24, 27, 0.10);
  }
`;

interface PresentationPreviewPaneProps {
  orderId: string;
  title?: string;
}

export default function PresentationPreviewPane({
  orderId,
  title = 'Presentation preview',
}: PresentationPreviewPaneProps) {
  const [isIframeLoading, setIsIframeLoading] = useState(true);
  const previewRevision = useSelector(selectPreviewRevision);
  const src = `${window.location.origin}/order/${orderId}?hideHelp=true&previewShop=true&r=${previewRevision}`;

  useEffect(() => {
    setIsIframeLoading(true);
  }, [src]);

  return (
    <PreviewPaneRoot>
      <ResponsivePreview
        id="presentation-builder-preview-iframe"
        display="desktop"
        src={src}
        title={title}
        allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        containerStyle={{ height: '100%', width: '100%' }}
        isLoading={isIframeLoading}
        onLoad={() => setIsIframeLoading(false)}
      />
    </PreviewPaneRoot>
  );
}
